import script from "./boto.vue?vue&type=script&setup=true&lang=js"
export * from "./boto.vue?vue&type=script&setup=true&lang=js"

import "./boto.vue?vue&type=style&index=0&id=633c8b7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633c8b7e"]])

export default __exports__